import React from 'react'
import RootComponent from './RootComponent'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import english from './resources/locales/en.json'
import italian from './resources/locales/it.json'
import french from './resources/locales/fr.json'
import spanish from './resources/locales/es.json'
import portoguese from './resources/locales/pt.json'
import german from './resources/locales/de.json'

export const availableTranslations = {
    en: {
        translation: english
    },
    it: {
        translation: italian
    },
    fr: {
        translation: french
    },
    es: {
        translation: spanish
    },
    pt: {
        translation: portoguese
    },
    de: {
        translation: german
    }
}

const FALLBACK_LANGUAGE = 'en'

i18n.use(initReactI18next).init({
    resources: availableTranslations,
    lng: navigator.language ? navigator.language : FALLBACK_LANGUAGE,
    fallbackLng: FALLBACK_LANGUAGE,
    interpolation: {
        escapeValue: false
    },
    // Show final piece of key if the translation doesn't exist
    saveMissing: true,
    parseMissingKeyHandler: (key) => {
        const splittedKey = key.split('.')
        return splittedKey[splittedKey.length - 1]
    },
    missingKeyHandler: () => null
})

const App: React.FC = () => {
    return <RootComponent />
}

export default App
